import{InjectionToken}from'@angular/core';
import { AppEnvironmentConfig } from './interfaces/app-environment-config';

export const TT_LIB_ENV_CONFIG = new InjectionToken<AppEnvironmentConfig>(
    'TT_LIB_ENV_CONFIG'
    );